import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-small-screen',
  templateUrl: './small-screen.component.html',
  styleUrls: ['./small-screen.component.scss']
})
export class SmallScreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
